export enum FunctionCode {
  RULE_ENGINE_EDITOR = 'ruleEngineEditor',
  CREDIT_ROLE_PERM = 'RetailCreditRolePermSettings',
  WATCH_LIST = 'RetailWatchList',
  SHIFT_SETTING = 'RetailShiftSetting',
  ANNOUNCEMENT = 'RetailAnnouncement',
  ProductParameter = 'RetailProductParameter',
  APPROVAL_APPLY = 'RetailApply',
  APPROVAL_AMENDMENT = 'RetailAmendment',
  APPROVAL_APPEAL = 'RetailAppeal',
  APPROVAL_BATCHEXTENSION = 'RetailDealerBatchExtension',
  APPROVAL_REASSIGN = 'RetailReAssignSettings',
  MERCHANT_DEALER_INFO = 'RetailDealerInformation',
  MERCHANT_DEALER_LEVEL = 'RetailDealerHierarchySettings',
  CONSUMER_INFO = 'RetailConsumerBasicInfo',
  CONSUMER_APPLY = 'RetailConsumerApply',
  RETAIL_COMMENCEMENT_APPLY = 'RetailCommencementApply',
  RETAIL_CUSTOMER_SERVICE_MSG_MAINTN = 'RetailCustomerServiceMsgMaintn',
  CREDIT_ASSIGN_RULE_SETTING = 'RetailCreditAssignRuleSettings',
}
